import { ADMISSIONS_ACCESS } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

export default [
    {
        path: 'admissions/:activeDialog?/:activeId?/:activeGroupId?',
        name: 'admissions',
        // The router's global guard enforces this. Without it the dashboard is reachable by
        // typing the URL, and it lists prospects who are deliberately hidden from contact lists.
        meta: { label: 'Admissions', hasPermission: ADMISSIONS_ACCESS },
        // Hiding the nav item is not the gate: the flag has to be checked here too, or the
        // destination stays reachable by URL in an account the feature has not reached yet.
        beforeEnter: () => {
            if (!useFeatureFlags().isEnabled('admissions')) return { name: 'home' };
        },
        component: () => import('../views/AdmissionsPage.vue'),
        props: true,
    },
];
